(function() {
    'use strict';

    angular.module('GorillaBoy.Login')
    .controller('InviteController', [
        '$scope',
        '$location',
        '$window',
        '$log',
        '$route',
        'EndpointService',
        'AppConstants',
        'SessionManager',
        InviteController
    ]);

    /**
     * InviteController is invoked when a user follows the link in an invitation e-mail.
     *
     */
    function InviteController ($scope, $location, $window, $log, $route, endpointService, AppConstants, SessionManager) {
        var
            REDIRECT_URI_PARAM_NAME = 'redirect_uri',
            INVITE_STATE_PARAMETER = 'state',
            TLD_REGEX = new RegExp('([a-zA-Z0-9-])+\.awsapps\.(net|com)'),
            AUTH_REGEX = new RegExp('([a-zA-Z0-9-])+\.amazonaws\.com'),
            PROD_REDIRECT = 'https://gb-prod-common.s3.amazonaws.com/redirect.html';


        activate();
        
        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate () {
            $log.debug(new Date().toISOString() + ' [InviteController] Initiating invitation flow');

            var querystring_params = $location.search();
            
            // construct invite url
            if (querystring_params && querystring_params[REDIRECT_URI_PARAM_NAME]) {
                var redirect_uri = querystring_params[REDIRECT_URI_PARAM_NAME];
                processRedirectUri(redirect_uri, querystring_params[INVITE_STATE_PARAMETER]);
            } else {
                // Invalid invite link, there's nothing we can do other than redirect to login page
                // invalid invite link, go to login page
                $location.path('/login');
            }
        }

        function processRedirectUri (inviteRedirectUri, inviteState) {
            var redirectUrl, inviteUrl;

            // Create an anchor element to determine the hostname part of the URL
            var anchorEl = document.createElement('a');
            anchorEl.href = inviteRedirectUri;

            if (TLD_REGEX.test(anchorEl.hostname) || AUTH_REGEX.test(anchorEl.hostname)) {
                redirectUrl = endpointService.oauth2CallbackEndpoint();
                inviteUrl = inviteRedirectUri +
                    '&client_id=' + endpointService.clientId() +
                    '&redirect_uri=' + encodeURIComponent(redirectUrl);

                // save invite state to cookie if presents
                if (inviteState) {
                    SessionManager.setRedirectState(inviteState);
                } else {
                    SessionManager.resetRedirectState();
                }
                // Redirect to the OAuth2 provider.
                $scope.changeWindowLocationHref(inviteUrl);                
            } else {
                $scope.changeWindowLocationHref(PROD_REDIRECT);                
            }
        }
    }
}());
